import React from 'react';
import { createPortal } from 'react-dom';

type AppModalProps = {
  show: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  closeDisabled?: boolean;
};

const AppModal: React.FC<AppModalProps> = ({
  show,
  title,
  onClose,
  children,
  footer,
  size = 'lg',
  closeDisabled = false
}) => {
  if (!show) return null;
  if (typeof document === 'undefined') return null;

  const sizeClass = size ? `modal-${size}` : '';

  return createPortal(
    <>
      <div className="modal fade show d-block" tabIndex={-1} role="dialog" aria-modal="true">
        <div className={`modal-dialog modal-dialog-centered ${sizeClass}`.trim()} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={onClose} disabled={closeDisabled} />
            </div>
            <div className="modal-body">
              {children}
            </div>
            {footer && <div className="modal-footer">{footer}</div>}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>,
    document.body
  );
};

export default AppModal;
